/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientEncounterHistoryModel } from '../../models/patient-encounter-history-model';

export interface PatientEncounterHistoryPatientIdGet$Params {
  patientId: string;
  startDate?: string | null;
  endDate?: string | null;
}

export function patientEncounterHistoryPatientIdGet(http: HttpClient, rootUrl: string, params: PatientEncounterHistoryPatientIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterHistoryModel>> {
  const rb = new RequestBuilder(rootUrl, patientEncounterHistoryPatientIdGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientEncounterHistoryModel>;
    })
  );
}

patientEncounterHistoryPatientIdGet.PATH = '/Patient/EncounterHistory/{patientId}';
